import React from 'react';
import { srcSetFor, backdropUrl } from '../responsiveImage';

function EventCard({ event, isAuthenticated, onDelete, onEdit, onViewPage, onImageClick }) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden grid grid-cols-1 md:grid-cols-3 hover-lift relative">
      {isAuthenticated && (
        <div className="absolute top-4 right-4 flex gap-2" style={{ zIndex: 10 }}>
          <button onClick={() => onEdit(event)} aria-label={`Edit ${event.title}`} className="bg-blue-600 hover:bg-blue-700 text-white w-10 h-10 rounded-full flex items-center justify-center transition shadow-lg">✏️</button>
          <button onClick={() => onDelete(event.id)} aria-label={`Delete ${event.title}`} className="bg-red-600 hover:bg-red-700 text-white w-10 h-10 rounded-full flex items-center justify-center transition shadow-lg">✕</button>
        </div>
      )}
      {event.image ? (
        <button
          type="button"
          onClick={() => onImageClick && onImageClick(event.image, event.title)}
          aria-label={`View larger photo for ${event.title}`}
          className="w-full border-0 p-0 block"
          // Two independent layers, so the photo can never be cropped no matter
          // what height this cell ends up at. As a grid item it gets stretched
          // to the text column's height, which is taller than the 2:1 the
          // padding asks for — a single `cover` image would be cut to fill that.
          //
          // Background: a blurred wash, stretched to cover. It holds no legible
          // detail, so scaling or cropping it is harmless, and it guarantees the
          // cell is always filled whatever height it lands at.
          style={{
            position: 'relative',
            paddingTop: '50%',
            overflow: 'hidden',
            cursor: 'pointer',
            backgroundColor: '#722f37',
            backgroundImage: backdropUrl(event.image) ? `url("${backdropUrl(event.image)}")` : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {/* Foreground: the photo itself, `contain`, so every edge stays visible. */}
          <img
            src={event.image}
            srcSet={srcSetFor(event.image)}
            sizes="(min-width: 768px) 33vw, 100vw"
            alt={event.title}
            loading="lazy"
            decoding="async"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </button>
      ) : (
        <div
          className="event-gradient flex items-center justify-center text-white text-6xl"
          style={{ position: 'relative', paddingTop: '50%', overflow: 'hidden' }}
          aria-hidden="true"
        >
          <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            {event.emoji}
          </span>
        </div>
      )}
      <div className="col-span-2 p-8">
        <div className="text-gold-dark font-bold mb-2">{event.date}</div>
        <h3 className="text-3xl font-bold text-wine mb-4">{event.title}</h3>
        <p className="text-gray-600 mb-4">{event.description}</p>
        {/* Only render a call to action when there is somewhere to go; this
            used to be a dead href="#" that jumped to the top of the page. */}
        {event.hasPage && (
          <button onClick={() => onViewPage(event.id)} className="text-wine font-bold hover:text-gold-dark transition">
            View Full Page <span aria-hidden="true">→</span>
          </button>
        )}
      </div>
    </div>
  );
}

export default EventCard;